import { Box, styled } from "@mui/material"

export const PageContentContainer = styled(Box)(() => ({
  padding: "30px 20px",
  display: "flex",
  height: "calc(100vh - 120px)",
  maxWidth: 440,
  margin: "0 auto",
}))
